import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {BulkActionIdSelector, BulkActionShownSelector, BulkActionTaskSelector} from 'src/components/bulk-tool/typedef';
import type {AppState} from 'src/store/typedef';

export const unassignProductSeatSlice = getBulkActionSlice('unassignProductSeatResult');
export const selectUnassignProductSeatUuid: BulkActionIdSelector = (state: AppState) =>
    state.bulkUpdateResult.unassignProductSeatResult.uuid;
export const selectUnassignProductSeatShown: BulkActionShownSelector = (state: AppState) =>
    state.bulkUpdateResult.unassignProductSeatResult.shown;
export const selectUnassignProductSeatTask: BulkActionTaskSelector = (state: AppState) =>
    state.bulkUpdateResult.unassignProductSeatResult.backgroundTask;
export const {setUuid, setShown, setBackgroundTask, clearResult} = unassignProductSeatSlice.actions;
